module.exports = __webpack_public_path__ + "Illustration-1.svg?8336d0c18927c2e104b0a935411b03d9";